import { HistoryOutlined } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { Category, Document } from 'interfaces/documents';
import { isDocument } from '../../../../utilities/constants';
import { MenuItemType } from 'antd/es/menu/interface';

export const History = (
    row: Category | Document,
): MenuItemType => {
    const { openModal } = useModal();

    return {
        key: 'History',
        label: 'History',
        icon: <HistoryOutlined />,
        onClick: () => {
            openModal('historyModal', {
                id: isDocument(row) ? (row as Document).id : (row as Category).uuid,
            });
        },
    };
};